import { StyleSheet } from 'react-native'
import { Box, Text, useTheme } from '../theme/restyle'
import { KYC_FORM_METRICS } from './kycFormTheme'

export function FiatErrorNotice({ message }: { message: string }) {
  const theme = useTheme()
  return (
    <Box
      accessibilityRole="alert"
      style={[styles.notice, { backgroundColor: theme.form.errorNotice.fill }]}
    >
      <Text style={[styles.copy, { color: theme.form.errorNotice.content }]}>
        {message}
      </Text>
    </Box>
  )
}
const styles = StyleSheet.create({
  notice: {
    minHeight: 60,
    borderRadius: 26,
    paddingHorizontal: 16,
    paddingVertical: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  copy: {
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: KYC_FORM_METRICS.noticeTracking,
    textAlign: 'center',
  },
})
